/**
 * Selection Store — what's currently selected across panels
 */
import { createStore } from 'zustand/vanilla';
import type { SelectionTarget } from '@graphicsim/shared-types';
import { eventBus } from '../engine/eventBus';

export interface SelectionState {
  current: SelectionTarget;
  // Multi-select for project items
  selectedProjectItemIds: string[];
  // Actions
  select: (target: SelectionTarget) => void;
  selectProjectItems: (ids: string[]) => void;
  addProjectItem: (id: string) => void;
  toggleProjectItem: (id: string) => void;
  clearSelection: () => void;
}

export const selectionStore = createStore<SelectionState>((set, get) => ({
  current: { type: 'none' },
  selectedProjectItemIds: [],

  select: (target) => {
    set({ current: target });
    if (target.type === 'projectItem') {
      set({ selectedProjectItemIds: [target.itemId] });
    }
    eventBus.emit('selection:changed', { target });
  },

  selectProjectItems: (ids) => {
    set({
      selectedProjectItemIds: ids,
      current: ids.length === 1 ? { type: 'projectItem', itemId: ids[0] } : { type: 'none' },
    });
  },

  addProjectItem: (id) => {
    const ids = [...get().selectedProjectItemIds, id];
    set({
      selectedProjectItemIds: ids,
      current: ids.length === 1 ? { type: 'projectItem', itemId: ids[0] } : { type: 'none' },
    });
  },

  toggleProjectItem: (id) => {
    const current = get().selectedProjectItemIds;
    const ids = current.includes(id) ? current.filter((i) => i !== id) : [...current, id];
    set({
      selectedProjectItemIds: ids,
      current: ids.length === 1 ? { type: 'projectItem', itemId: ids[0] } : { type: 'none' },
    });
  },

  clearSelection: () => {
    set({ current: { type: 'none' }, selectedProjectItemIds: [] });
    eventBus.emit('selection:changed', { target: { type: 'none' } });
  },
}));
